import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

type TooltipContentProps = ComponentProps<typeof TooltipPrimitive.Content>;

interface TooltipProps {
  children: ReactNode;
  content: ReactNode;
  description?: ReactNode;
  side?: TooltipContentProps["side"];
  align?: TooltipContentProps["align"];
  delayDuration?: number;
}

export function Tooltip({
  children,
  content,
  description,
  side = "top",
  align = "center",
  delayDuration = 100,
}: TooltipProps) {
  return (
    <TooltipPrimitive.Provider delayDuration={delayDuration}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Content
          side={side}
          align={align}
          className={cn(
            "z-50 max-w-xs rounded-lg border border-white/10 bg-carbon-900/95 px-3 py-2 text-left text-xs text-white shadow-lg backdrop-blur"
          )}
        >
          <div className="space-y-1">
            <p className="font-semibold text-[0.6rem] uppercase tracking-[0.20em] text-white/80">
              {content}
            </p>
            {description ? (
              <p className="text-[0.6rem] leading-snug text-white/60">
                {description}
              </p>
            ) : null}
          </div>
          <TooltipPrimitive.Arrow className="fill-carbon-900/95" />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
